import { useEffect, useMemo } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";
import { SITE_URL } from "@/constants";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import AboutSection from "./components/AboutSection";
import FeaturesSection from "./components/FeaturesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import FeaturedSection from "./components/FeaturedSection";
import ArticlesSection from "./components/ArticlesSection";
import TrustSection from "./components/TrustSection";
import NoticeSection from "./components/NoticeSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  const websiteSchema = useMemo(() => ({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "OOPBuy Spreadsheet",
    "url": SITE_URL,
    "description": "The ultimate product research and sourcing database using structured OOPBuy spreadsheets. Discover, analyze, and compare high-performing products for smarter e-commerce decisions.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${SITE_URL}/?s={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  }), []);

  const webpageSchema = useMemo(() => ({
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "OOPBuy Spreadsheet - Ultimate Product Research & Sourcing Database",
    "url": SITE_URL,
    "description": "Discover, analyze, and compare high-performing products using structured OOPBuy spreadsheets designed for modern e-commerce sellers. Updated regularly, data-driven insights, beginner friendly.",
    "isPartOf": {
      "@type": "WebSite",
      "name": "OOPBuy Spreadsheet",
      "url": SITE_URL
    }
  }), []);

  useEffect(() => {
    document.title = "OOPBuy Spreadsheet - Ultimate Product Research & Sourcing Database | oopbuyspreadsheets.lat";
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema as Record<string, unknown>} />
      <JsonLd data={webpageSchema as Record<string, unknown>} />

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <AboutSection />
        <FeaturesSection />
        <HowItWorksSection />
        <FeaturedSection />
        <ArticlesSection />
        <TrustSection />
        <NoticeSection />
        <CtaSection />
      </main>

      <Footer />
    </div>
  );
}